import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import("./apps/Index.vue"),
  },
  {
    path: "/control_seguimientos_cheques",
    component: () => import("./apps/cheques/ControlCheques.vue"),
  },
  {
    path: "/adm_usuarios",
    component: () => import("./apps/administracion/AdmUsuarios.vue"),
  },
  {
    path: "/adm_suscripciones",
    component: () => import("./apps/administracion/AdmSuscripciones.vue"),
  },
  {
    path: "/adm_crm",
    component: () => import("./apps/administracion/AdmCRM.vue"),
  },
  {
    path: "/adm_growth",
    component: () => import("./apps/administracion/AdmGrowth.vue"),
  },
  {
    path: "/adm_agente_ia",
    component: () => import("./apps/administracion/AdmAgenteIA.vue"),
  },
  {
    path: "/adm_contador",
    component: () => import("./apps/administracion/AdmContador.vue"),
  },
  {
    path: "/adm_clasificaciones",
    component: () => import("./apps/formulario/clasificaciones/AdmClasificaciones.vue"),
  },
  {
    path: "/adm_sugerencias",
    component: () => import("./apps/formulario/sugerencias/AdmSugerencias.vue"),
  },
  {
    path: "/reglas_clasificacion",
    component: () => import("./apps/formulario/reglas/AdmReglasClasificacion.vue"),
  },
  {
    path: "/asociar_empresa",
    component: () => import("./apps/administracion/AsociarEmpresa.vue"),
  },
  {
    path: "/config_itsave",
    component: () => import("./apps/administracion/ConfiguracionItsave.vue"),
  },
  {
    path: "/admin_api_config",
    component: () => import("./apps/administracion/AdminApiConfig.vue"),
  },
  {
    path: "/metricas_northstar",
    component: () => import("./apps/administracion/MetricasNorthStar.vue"),
  },
  {
    path: "/subir_proveedores_new",
    component: () => import("./apps/administracion/SubirProveedores.vue"),
  },
  {
    path: "/resumen_ventas",
    component: () => import("./apps/gestionTributaria/Resumen/ResumenVentas.vue"),
  },
  {
    path: "/resumen_compras",
    component: () => import("./apps/gestionTributaria/Resumen/ResumenCompras.vue"),
  },
  {
    path: "/configurar_empresa",
    component: () => import("./apps/administracion/ConfigurarEmpresa.vue"),
  },
  {
    path: "/adm_proveedores_new",
    component: () => import("./apps/administracion/AdmProveedores.vue"),
  },
  {
    path: "/proveedores_masivo",
    component: () => import("./apps/administracion/acciones_masivas/ProveedoresMasivo.vue"),
  },
  {
    path: "/clasificacion_masiva",
    component: () => import("./apps/administracion/acciones_masivas/ClasificacionMasiva.vue"),
  },
  {
    path: "/adm_trabajadores_new",
    component: () => import("./apps/administracion/AdmTrabajadores.vue"),
  },
  {
    path: "/subir_trabajadores_new",
    component: () => import("./apps/administracion/SubirTrabajadores.vue"),
  },
  {
    path: "/asociar_usuario_new",
    component: () => import("./apps/administracion/AsociarUsuario.vue"),
  },
  {
    path: "/adm_cuentas_bancarias",
    component: () => import("./apps/administracion/AdmCuentasBancarias.vue"),
  },
  {
    path: "/eliminar_movimientos_archivo",
    component: () => import("./apps/administracion/EliminacionMovimientos.vue"),
  },
  {
    path: "/configurar_eerr",
    component: () => import("./apps/administracion/ConfigurarEERR.vue"),
  },
  {
    path: "/configurar_limite",
    component: () => import("./apps/administracion/ConfigurarLimite.vue"),
  },
  {
    path: "/terminos_y_condiciones",
    component: () => import("./apps/TerminosyCondiciones.vue"),
  },
  {
    path: "/politica_privacidad",
    component: () => import("./apps/PoliticaPrivacidad.vue"),
  },
  {
    path: "/home",
    component: () => import("./apps/dashboard/DashboardRoot.vue"),
  },
  {
    path: "/math-game",
    component: () => import("./apps/MathGame.vue"),
  },
  {
    path: "/facturacion_suscripcion",
    component: () => import("./apps/facturas/FacturacionSuscripcion.vue"),
  },
  {
    path: "/integraciones",
    component: () => import("./apps/conexiones/Conexiones.vue"),
  },
  {
    path: "/integraciones/previred",
    component: () => import("./apps/conexiones/Previred.vue"),
  },
  {
    path: "/integraciones/mercadopago",
    component: () => import("./apps/conexiones/MercadoPago.vue"),
  },
  {
    path: "/integraciones/shopify",
    component: () => import("./apps/conexiones/Shopify.vue"),
  },
  {
    path: "/cGFnb19leGl0b3Nv", // "pago_exitoso sin trackeo"
    component: () => import("./apps/onboarding/Pago_exitoso.vue"),
  },
  {
    path: "/cGFnb19mYWxsaWRv", // "pago_exitoso con trackeo"
    component: () => import("./apps/onboarding/Pago_exitoso_track.vue"),
  },
  {
    path: "/procesando_pago",
    component: () => import("./apps/onboarding/Procesando_pago.vue"),
  },
  {
    path: "/reactivar-suscripcion",
    component: () => import("./apps/reactivacion/ReactivarSuscripcion.vue"),
  },
  {
    path: "/reactivar-suscripcion/empresa",
    component: () => import("./apps/reactivacion/ReactivarSuscripcion.vue"),
  },
  {
    path: "/pago_anual",
    component: () => import("./apps/onboarding/PagoAnual.vue"),
  },
  {
    path: "/onboarding",// 12.990 sin trackeo
    component: () => import("./apps/onboarding/OnBoarding_1.vue"),
  },
  {
    path: "/uno",//12.990 trackeo
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/anuala",//Basic anual
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/anualb",//Business anual
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/unob",//49.990 sin trackeo
    component: () => import("./apps/onboarding/OnBoarding_1_b.vue"),
  },
  {
    path: "/unoc",//ya pagado
    component: () => import("./apps/onboarding/OnBoarding_1_c.vue"),
  },
  {
    path: "/unod",//con dcto vendedor
    component: () => import("./apps/onboarding/OnBoarding_1_d.vue"),
  },
  {
    path: "/unoe",//plan semestral asistente financiero
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/unof",//plan anual asistente financiero
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/unog",//plan mensual contador ai
    component: () => import("./apps/onboarding/OnBoarding_1_normal.vue"),
  },
  {
    path: "/dos",
    component: () => import("./apps/onboarding/OnBoarding_2.vue"),
  },
  {
    path: "/tres",
    component: () => import("./apps/onboarding/OnBoarding_3.vue"),
  },
  {
    path: "/cuatro",
    component: () => import("./apps/onboarding/OnBoarding_4.vue"),
  },
  {
    path: "/cinco",
    component: () => import("./apps/onboarding/OnBoarding_5.vue"),
  },
  {
    path: "/seis",
    redirect: "/proveedores",
  },
  {
    path: "/onboarding_graph",
    component: () => import("./apps/onboarding/OnBoarding_graph.vue"),
  },
  {
    path: "/movimientos_bancarios",
    component: () => import("./apps/modoAsesor/VistaPorModoAsesor.vue"),
    props: { vista: "movimientos" },
  },
  {
    path: "/movimientos_bancarios_v2",
    component: () => import("./apps/movimientos_bancarios/MovimientosBancariosV2.vue"),
  },
  {
    path: "/pagos_masivos",
    component: () => import("./apps/pagos_masivos/PagosMasivos.vue"),
  },
  {
    path: "/pagos_masivos/configuracion",
    component: () => import("./apps/pagos_masivos/ConfiguracionPagosMasivos.vue"),
  },
  {
    path: "/proveedores",
    component: () => import("./apps/ProveedoresUser.vue"),
  },
  {
    path: "/clientes",
    component: () => import("./apps/ClientesUser.vue"),
  },
  {
    path: "/trabajadores",
    component: () => import("./apps/trabajadores/TrabajadoresUsuario.vue"),
  },
  {
    path: "/index_formulario",
    component: () => import("./apps/formulario/IndexFormulario.vue"),
  },
  {
    path: "/create_formulario",
    component: () => import("./apps/formulario/CreateFormulario.vue"),
  },
  {
    path: "/edit_formulario",
    component: () => import("./apps/formulario/EditFormulario.vue"),
  },
  {
    path: "/show_respuestas",
    component: () => import("./apps/formulario/respuestasFormulario/ShowRespuestas.vue"),
  },
  {
    path: "/edit_preguntas_formulario",
    component: () => import("./apps/formulario/EditFormularioPreguntas.vue"),
  },
  {
    path: "/edit_preguntas_formulario_empresas",
    component: () => import("./apps/formulario/EditFormularioPreguntasEmpresas.vue"),
  },
  {
    path: "/mi_budget",
    component: () => import("./apps/Budget.vue"),
  },
  {
    path: "/notificaciones_alertas_recordatorios",
    component: () => import("./apps/notificaciones/Notificaciones_alertas_recordatorios.vue"),
  },
  {
    path: "/adm_ejecutivos",
    component: () => import("./apps/administracion/AdmEjecutivos.vue"),
  },
  {
    path: "/graficas",
    component: () => import("./apps/administracion/Graficas.vue"),
  },
  {
    path: "/configuracion",
    component: () => import("./apps/usuario/UserConfiguracion.vue"),
  },
  {
    path: "/configuracion_extensiones",
    component: () => import("./apps/conexiones/Conexiones.vue"),
    props: { initialSection: "extensions" },
  },
  {
    path: "/api_movimientos_config",
    component: () => import("./apps/usuario/ApiMovimientosConfig.vue"),
  },
  {
    path: "/sii",
    component: () => import("./apps/usuario/Sii.vue"),
  },
  {
    path: "/password",
    component: () => import("./apps/usuario/UpdatePassword.vue"),
  },
  {
    path: "/logo",
    component: () => import("./apps/usuario/Logo.vue"),
  },
  {
    path: "/cuentas_por_cobrar",
    component: () => import("./apps/cuentasPc/CuentasPorCobrar.vue"),
  },
  {
    path: "/cuentas_por_pagar",
    component: () => import("./apps/cuentasPc/CuentasPorPagar.vue"),
  },
  {
    path: "/botchat",
    component: () => import("./apps/bot/Botchat.vue"),
  },
  {
    path: "/panel_mensajeria",
    component: () => import("./apps/administracion/PanelMensajeria.vue"),
  },
  {
    path: "/subir_cartola",
    component: () => import("./apps/administracion/SubirCartola.vue"),
  },
  {
    path: "/index_empresas_new",
    component: () => import("./apps/administracion/IndexEmpresas.vue"),
  },
  {
    path: "/panel_instrucciones",
    component: () => import("./apps/bot/PanelInstrucciones.vue"),
  },
  {
    path: "/panel_preguntas_bot",
    component: () => import("./apps/bot/PanelPreguntas.vue"),
  },
  {
    path: "/test_agente",
    component: () => import("./apps/agente/TestAgente.vue"),
  },
  {
    path: "/adm_ingresos",
    component: () => import("./apps/registroIngresos/AdmIngresos.vue"),
  },
  {
    path: "/create_ingreso_registro",
    component: () => import("./apps/registroIngresos/CreateIngresoRegistro.vue"),
  },
  {
    path: "/edit_ingreso_registro",
    component: () => import("./apps/registroIngresos/EditIngresoRegistro.vue"),
  },
  {
    path: "/mis_impuestos",
    component: () => import("./apps/gestionTributaria/MisImpuestos/MisImpuestos.vue"),
  },
  {
    path: "/compras",
    component: () => import("./apps/gestionTributaria/MisImpuestos/Compras.vue"),
  },
  {
    path: "/ventas",
    component: () => import("./apps/gestionTributaria/MisImpuestos/Ventas.vue"),
  },
  {
    path: "/flujo_de_caja",
    component: () => import("./apps/modoAsesor/VistaPorModoAsesor.vue"),
    props: { vista: "flujo" },
  },
  {
    path: "/estado_resultados",
    component: () => import("./apps/gestionTributaria/EstadoResultadosProximamente.vue"),
  },
  {
    path: "/configuracion_ingresos",
    component: () => import("./apps/gestionTributaria/ConfiguracionGastosCostos/ConfiguracionGastosCostos.vue"),
  },
  {
    path: "/configuracion_gastos_costos",
    component: () => import("./apps/modoAsesor/VistaPorModoAsesor.vue"),
    props: { vista: "gastos" },
  },
  {
    path: "/conexion_bancaria",
    component: () => import("./apps/usuario/FinctocBanco.vue"),
  },
  {
    path: "/mensajes_wsp",
    component: () => import("./apps/usuario/Wsp.vue"),
  },
  {
    path: "/conexion_losheroes",
    component: () => import("./apps/usuario/LosHeroes.vue"),
  },
  {
    path: "/conexion_falabella",
    component: () => import("./apps/usuario/Falabella.vue"),
  },
  {
    path: "/conciliar_movimientos_new",
    component: () => import("./apps/administracion/Conciliar_movimientos/ConciliarMovimientos.vue"),
  },
  {
    path: "/adm_diagnostico_new",
    component: () => import("./apps/administracion/AdmDiagnostico.vue"),
  },
  {
    path: "/subir_health_score",
    component: () => import("./apps/administracion/ActualizarHealthScrore.vue"),
  },
  {
    path: "/configuracion_proyecto",
    component: () => import("./apps/gestionTributaria/GastosPorProyecto/ConfiguracionProyecto.vue"),
  },
  {
    path: "/resumen_proyectos",
    component: () => import("./apps/gestionTributaria/GastosPorProyecto/ResumenProyectos.vue"),
  },
  {
    path: "/flujo_proyectos",
    component: () => import("./apps/gestionTributaria/GastosPorProyecto/DetalleFlujo.vue"),
  },
  {
    path: "/administrar_alarmas",
    component: () => import("./apps/gestionTributaria/GastosPorProyecto/AdministrarAlarmas.vue"),
  },
  {
    path: "/administrar_proyectos",
    component: () => import("./apps/administracion/AdministrarProyectos.vue"),
  },
  {
    path: "/webhook_mensajes",
    component: () => import("./apps/webhookmeta/WebhookMensajes.vue"),
  },
  {
    path: "/mercadopago",
    redirect: "/integraciones/mercadopago",
  },
  {
    path: "/administrar_correos_notificaciones",
    component: () => import("./apps/correos_notificaciones/AdministrarCorreosNotificaciones.vue"),
  },
  {
    path: "/centro_correos",
    component: () => import("./apps/correos_notificaciones/CentroCorreos.vue"),
  },
  {
    path: "/calendario_financiero",
    component: () => import("./apps/calendario_financiero/CalendarioFinanciero.vue"),
  },
  {
    path: "/estados_pagos_cobros",
    component: () => import("./apps/calendario_financiero/EstadosPagosCobros.vue"),
  },
  {
    path: "/contador_ai",
    component: () => import("./apps/contador_ai/DashboardContadorAiNuevo.vue"),
  },
  {
    path: "/impuestos_mensuales",
    component: () => import("./apps/contabilidad/ImpuestosMensuales.vue"),
  },
  {
    path: "/libro_honorarios",
    component: () => import("./apps/contabilidad/LibroHonorarios.vue"),
  },
  {
    path: "/libro_ventas",
    component: () => import("./apps/contabilidad/LibroVentas.vue"),
  },
  {
    path: "/libro_compras",
    component: () => import("./apps/contabilidad/LibroCompras.vue"),
  },
  {
    path: "/libro_remuneraciones",
    component: () => import("./apps/contabilidad/LibroRemuneraciones.vue"),
  },
  {
    path: "/rrhh",
    component: () => import("./apps/contabilidad/RRHH.vue"),
  },
  {
    path: "/documentos",
    component: () => import("./apps/contabilidad/DocumentosContabilidad.vue"),
  },
  {
    path: "/administrar_permisos_empresas",
    component: () => import("./apps/administracion/AdmPermisosEmpresas.vue"),
  },
  {
    path: "/adm_tutoriales",
    component: () => import("./apps/administracion/AdmTutoriales.vue"),
  },
  {
    path: "/agente_facturador",
    component: () => import("./apps/agente_facturador/AgenteFacturador.vue"),
  },
  {
    path: "/documentos_emitidos",
    component: () => import("./apps/agente_facturador/DocumentosEmitidos.vue"),
  },
  {
    path: "/emisiones_masivas",
    component: () => import("./apps/agente_facturador/EmisionesMasivas.vue"),
  },
  {
    path: "/configuracion_cotizaciones",
    component: () => import("./apps/agente_facturador/ConfiguracionCotizaciones.vue"),
  },
  {
    path: "/crear_cuenta_obfact",
    component: () => import("./apps/onboarding/facturador/CrearCuentaOBFact.vue"),
  },
  {
    path: "/enlazar_whatsapp_obfact",
    component: () => import("./apps/onboarding/facturador/EnlazarWhatsappOBFact.vue"),
  },
  {
    path: "/datos_empresa_obfact",
    component: () => import("./apps/onboarding/facturador/DatosEmpresaOBFact.vue"),
  },
  {
    path: "/credenciales_facturador_obfact",
    component: () => import("./apps/onboarding/facturador/CredencialesFacturadorOBFact.vue"),
  },
  {
    path: "/pagar_suscripcion_facturador",
    component: () => import("./apps/onboarding/facturador/PagarSuscripcionFact.vue"),
  },
  {
    path: "/lN1p6jVGwobP8iTzKo5EdQWt", // plan 1 Básico
    component: () => import("./apps/onboarding/facturador/PagoExitosoFact.vue"),
  },
  {
    path: "/z5vU7S7MJyQZZqAmDTvFfFse", // plan 2 Medium
    component: () => import("./apps/onboarding/facturador/PagoExitosoFact.vue"),
  },
  {
    path: "/U4EUYSQEjMIXerQ-qOioCn6F", // plan 3 Pro
    component: () => import("./apps/onboarding/facturador/PagoExitosoFact.vue"),
  },
  {
    path: "/nueva_factura",
    component: () => import("./apps/agente_facturador/NuevaFactura.vue"),
  },
  {
    path: "/cotizaciones",
    component: () => import("./apps/agente_facturador/CotizacionesPage.vue"),
  },
  {
    path: "/gastos_exterior",
    component: () => import("./apps/agente_facturador/GastosExterior.vue"),
  },
  {
    path: "/cotizacion/:token",
    component: () => import("./apps/agente_facturador/CotizacionesPage.vue"),
  },
  {
    path: "/clientes_facturador",
    component: () => import("./apps/agente_facturador/ClientesFacturador.vue"),
  },
  {
    path: "/productos_facturador",
    component: () => import("./apps/agente_facturador/ProductosFacturador.vue"),
  },
  {
    path: "/configuracion_facturador",
    component: () => import("./apps/agente_facturador/ConfiguracionFacturador.vue"),
  },
  {
    path: "/dashboard_facturador",
    component: () => import("./apps/agente_facturador/DashboardFacturador.vue"),
  },
  {
    path: "/test_reportes",
    component: () => import("./apps/gestionTributaria/FlujoDeCaja/TestReportes.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

export default router;
